import { render, staticRenderFns } from "./anotherName .vue?vue&type=template&id=65257d7a&scoped=true&"
import script from "./anotherName .vue?vue&type=script&lang=js&"
export * from "./anotherName .vue?vue&type=script&lang=js&"
import style0 from "./anotherName .vue?vue&type=style&index=0&id=65257d7a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65257d7a",
  null
  
)

export default component.exports